

import { useDispatch } from "react-redux";
import { startLoading, endLoading } from "../store/slices/loadingSlice";

const useLoading = () => {
  const dispatch = useDispatch();

  const pushLoading = (isLoading: boolean) => {
    if (isLoading) {
      dispatch(startLoading()); // ﹢1
    }
    else {
      dispatch(endLoading()); // −1
    }
  };

  return pushLoading;
};

export default useLoading;
